// Not a failure: nothing can be listed until there is somewhere to deliver to.
// The grid shows it as a prompt, not as the red "couldn't load" state.
export const NEEDS_ADDRESS_MESSAGE = 'Enter an address to see nearby restaurants.';

// The ordering service (DoorDash, for the whole shared account) is rate
// limiting searches. Supplier-neutral; the grid adds when it searches again.
export const SEARCH_BUSY_MESSAGE = "The ordering service is busy right now, so restaurants can't load yet.";
// Our own API's per-user search quota.
export const SEARCH_THROTTLED_MESSAGE = "You've searched a lot in a short time, so restaurants can't load yet.";
// Any other failure. The raw text (provider, transport, input validation)
// goes to the console, never to the coach.
export const SEARCH_FAILED_MESSAGE = "We couldn't load restaurants right now. Try again in a minute.";
// A pilot coach who hasn't connected DoorDash (or whose sign-in expired):
// their restaurants come from their own DoorDash account. The grid adds a
// Connect DoorDash button instead of Try again.
export const SEARCH_NEEDS_DOORDASH_MESSAGE = 'Connect your DoorDash account to see restaurants. DoorDash orders run on your own DoorDash account.';
